export const uniqueArray = (arr: any[], field: string): any[] => {
  const keysMap: { [key: string]: any } = {};

  for (const item of arr) {
    keysMap[item[field]] = item;
  }
  return Object.values(keysMap);
};